/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import getBrandDomainById from '../../../../../../../helpers/getBrandDomain';
import findProductPageByPartNumberPersonalize from '../../../../../../../gql/queries/findProductPageByPartNumberPersonalize';

const GraphqlGetDisplayDeliveryCalendar = ({ render, brandId, productSku }) => {
    const brandDomain = getBrandDomainById(brandId);
    const query = findProductPageByPartNumberPersonalize(
        brandDomain,
        productSku,
        null,
    );

    const { error, loading, data } = useQuery(query);
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            component: 'GraphqlGetDisplayDeliveryCalendar.js',
            jsError: error,
            message: `Failed to fetch content data for: content type findProductPageByPartNumber for GraphqlGetDisplayDeliveryCalendar - query - ${query}`,
        });
    }
    if (loading) {
        return '';
    }
    const { displayDeliveryCalendar } = data?.findProductPageByPartNumber?.product || {};
    return render({
        displayDeliveryCalendar,
    });
};

export default GraphqlGetDisplayDeliveryCalendar;
